module.exports = __webpack_public_path__ + "static/media/dispatch_records_active.10cf0cd1.svg";